module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"100\" height=\"100\"><path d=\"M97 3v94H3V3h94m3-3H0v100h100V0z\" fill=\"#cf0\"/></svg>"